import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";
import {Product} from "../../models/shop/product";
import {ProductColor} from "../../models/shop/productColor";
import {ProductCategory} from "../../models/shop/productCategory";

@Injectable({
    providedIn: 'root'
})
export class ShopService {

    constructor(private http: HttpClient) {
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    getFormDataRequestHeaders() {
        return new HttpHeaders({
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    // Image
    async uploadImage(formData: FormData) {
        let responseUpload: any;
        try {
            responseUpload = await this.http.post(environment.apiUrl + `/productImages/upload`, formData, {
                headers: this.getFormDataRequestHeaders(),
            }).toPromise();

            return responseUpload

        } catch (e) {
            console.error('errorUploadCompany: ', e)
        }
    }

    // Products
    async getProducts(companyId: string) {
        let response: any = null;
        let params = {companyId: companyId}
        try {
            response = await this.http.get(environment.publicApiUrl + `/products`, {
                params: params,
                headers: this.getPublicRequestHeaders(),
            }).toPromise();

            return response.data;

        } catch (e) {
            console.error('error getProducts: ', e)
        }
    }

    async getProductById(productId: string) {
        let response: any;
        try {
            response = await this.http.get(environment.apiUrl + `/products/${productId}`, {
                headers: this.getRequestHeaders(),
            }).toPromise();
            return response;
        } catch (e) {
            console.error('error getProducts: ', e)
        }
    }

    async addProduct(newProduct: Product) {
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/products', newProduct, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error addProduct: ', e)
        } finally {
            return response;
        }
    }

    async deleteProduct(productId: string) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/products/${productId}`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteProduct: ', e)
        } finally {
            return response;
        }
    }

    async editProduct(editProduct: Product) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/products/${editProduct.id}`, editProduct, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteProduct: ', e)
        } finally {
            return response;
        }
    }

    // Sizes

    async getSizes(companyId: string) {
        let response: any = null;
        let params = {companyId: companyId}
        try {
            response = await this.http.get(environment.apiUrl + `/productSizes`, {
                params: params,
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getProducts: ', e)
        }
    }

    async addSize(newSize: Product) {
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/productSizes', newSize, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error addSize: ', e)
        } finally {
            return response;
        }
    }

    async editSize(productId: string, editSize: Product) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/productSizes/${productId}`, editSize, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteProduct: ', e)
        } finally {
            return response;
        }
    }

    async deleteSize(sizeId: string) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/productSizes/${sizeId}`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteSize: ', e)
        } finally {
            return response;
        }
    }

    async getColors(companyId: string) {
        let response: any = null;
        let params = {companyId: companyId}
        try {
            response = await this.http.get(environment.apiUrl + `/productColors`, {
                params: params,
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getProducts: ', e)
        }
    }


    async addColor(newColor: ProductColor) {
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/productColors', newColor, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error addColor: ', e)
        } finally {
            return response;
        }
    }

    async editColor(colorId: string, editColor: ProductColor) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/productColors/${colorId}`, editColor, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteProduct: ', e)
        } finally {
            return response;
        }
    }

    async deleteColor(colorId: string) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/productColors/${colorId}`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteColor: ', e)
        } finally {
            return response;
        }
    }

    getCategories(companyId: string) {
        let params = {companyId: companyId}
        return this.http.get(environment.apiUrl + '/productCategories/', {
            params: params,
            headers: this.getRequestHeaders()
        });
    }


    async addCategory(newCategory: ProductCategory) {
        let response: any;

        try {
            response = await this.http.post(environment.apiUrl + '/productCategories', newCategory, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error addColor: ', e)
        } finally {
            return response;
        }
    }

    async editCategory(categoryId: string, editCategory: ProductColor) {
        let response: any;

        try {
            response = await this.http.put(environment.apiUrl + `/productCategories/${categoryId}`, editCategory, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteProduct: ', e)
        } finally {
            return response;
        }
    }

    async deleteCategory(categoryId: string) {
        let response: any;

        try {
            response = await this.http.delete(environment.apiUrl + `/productCategories/${categoryId}`, {headers: this.getRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error deleteColor: ', e)
        } finally {
            return response;
        }
    }

    async getBarcodes(productId: string) {
        let response: any = null;
        try {
            let params = {productId: productId}
            response = await this.http.get(environment.apiUrl + `/productBarcodes`, {
                params: params,
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getBarcode: ', e)
        }
    }

    /*async getBarcodeById(barcodeId: string) {
        let response: any;
        try {
            response = await this.http.get(environment.apiUrl + `/productBarcodes/${barcodeId}`, {
                headers: this.getRequestHeaders(),
            }).toPromise();

        } catch (e) {
            console.error('error getBarcode: ', e)
        } finally {
            return response;
        }
    }*/

    getBarcodeById(barcodeId: string){
        return this.http.get(environment.apiUrl + `/productBarcodes/${barcodeId}`, {
            headers: this.getRequestHeaders()
        });
    }

    async addBarcode(barcode: any) {
        let response: any = null;
        try {
            response = await this.http.post(environment.apiUrl + `/productBarcodes`, barcode, {
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getBarcode: ', e)
        }
    }

    async editBarcode(barcode: any) {
        let response: any = null;
        try {
            response = await this.http.put(environment.apiUrl + `/productBarcodes/${barcode.id}`, barcode, {
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getBarcode: ', e)
        }
    }


    async deleteBarcode(barcodeId: string) {
        let response: any = null;
        try {
            response = await this.http.delete(environment.apiUrl + `/productBarcodes/${barcodeId}`, {
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getBarcode: ', e)
        }
    }

    getBarcodeMovementById(barcodeMovementId: string){
        return this.http.get(environment.apiUrl + `/productMovements/${barcodeMovementId}`, {
            headers: this.getRequestHeaders()
        });
    }

    addBarcodeMovement(barcodeMovement: any) {
        return this.http.post(environment.apiUrl + `/productMovements`, barcodeMovement, {
            headers: this.getRequestHeaders(),
        });
    }

    editBarcodeMovement(barcodeMovement: any) {
        return this.http.put(environment.apiUrl + `/productMovements/${barcodeMovement.id}`, barcodeMovement, {
            headers: this.getRequestHeaders(),
        });
    }


    async deleteBarcodeMovement(barcodeMovementId: string) {
        let response: any = null;
        try {
            response = await this.http.delete(environment.apiUrl + `/productMovements/${barcodeMovementId}`, {
                headers: this.getRequestHeaders(),
            }).toPromise();

            return response;

        } catch (e) {
            console.error('error getBarcode: ', e)
        }
    }

    async uploadProductImage(formData: FormData) {
        try {
            return await this.http.post(environment.apiUrl + `/products/upload`, formData, {headers: this.getFormDataRequestHeaders()}).toPromise();
        } catch (e) {
            console.error('error uploadProductImage: ', e)
            return false;
        }
    }


}


